import React from 'react';
import { BlockStack, Box, Card, InlineStack, Link, Text } from '@shopify/polaris';

// Source kinds in display order.
export const KINDS = [
  { kind: 'tag', label: 'Tags' }, { kind: 'type', label: 'Product type' }, { kind: 'title', label: 'Title' },
  { kind: 'vendor', label: 'Vendor' }, { kind: 'variant', label: 'Variants' }, { kind: 'existing', label: 'Already on the product' },
  { kind: 'learned_rule', label: 'Learned rules' }, { kind: 'team', label: 'Derived from team' },
  { kind: 'description', label: 'Description (vendor text)' }, { kind: 'description_ai', label: 'Description (AI)' },
  { kind: 'image', label: 'Image (AI)' }, { kind: 'vendor_page', label: 'Vendor pages' },
  { kind: 'retailer', label: 'Retailer pages' }, { kind: 'model', label: 'Model (category pick)' },
];
const ALIAS = { metafield: 'existing' };

export const sourceKind = (source) => { const k = String(source || '').split(':')[0]; return ALIAS[k] || k; };
export const isUrl = (s) => /^https?:\/\/\S+$/i.test(String(s || '').trim());

export function groupEvidence(evidence) {
  const groups = KINDS.map((k) => ({ ...k, records: [] }));
  const byKind = Object.fromEntries(groups.map((g) => [g.kind, g]));
  (evidence || []).forEach((e) => {
    const k = sourceKind(e.source);
    if (!byKind[k]) { byKind[k] = { kind: k, label: k || 'other', records: [] }; groups.push(byKind[k]); }
    byKind[k].records.push(e);
  });
  return groups;
}

const host = (u) => { try { return new URL(u).host; } catch { return u; } };

export default function EvidenceCard({ evidence, facetLabel }) {
  const groups = groupEvidence(evidence);
  return (
    <Card>
      <BlockStack gap="300">
        <Text as="h3" variant="headingSm">Evidence</Text>
        <Text as="p" tone="subdued">Everything the analysis found, by where it came from.</Text>
        {groups.map((g) => (
          <Box key={g.kind} paddingBlockStart="200" borderBlockStartWidth="025" borderColor="border">
            <BlockStack gap="100">
              <Text as="h4" variant="headingXs">{g.label} <Text as="span" tone="subdued" fontWeight="regular">({g.records.length})</Text></Text>
              {g.records.length === 0
                ? <Text as="p" tone="subdued">None</Text>
                : g.records.map((e, i) => (
                  <InlineStack key={i} gap="200" wrap blockAlign="baseline">
                    <Text as="span"><Text as="span" fontWeight="semibold">{facetLabel(e.facet)}</Text>: {String(e.value)}</Text>
                    <Text as="span" variant="bodySm" tone="subdued">{String(e.source || '')}{e.weight != null ? ` · weight ${e.weight}` : ''}</Text>
                    {e.detail && (isUrl(e.detail)
                      ? <Link url={e.detail} external monochrome removeUnderline={false}>{host(e.detail)}</Link>
                      : <Text as="span" variant="bodySm" tone="subdued">{String(e.detail)}</Text>)}
                  </InlineStack>
                ))}
            </BlockStack>
          </Box>
        ))}
      </BlockStack>
    </Card>
  );
}
